import React from "react";
import { Container } from "../../pages/AvaNegarLanding/index.styled";
import {
  UsageContainer,
  UsageListContainer,
  UsagesImgContainer,
  UsagesWrapper,
  TextContainer,
  TitleContainer,
} from "./index.styled";
import avaImg from "../../assets/images/avaImg.svg";

const Usages = () => {
  const usagesList = [
    { id: 1, content: "نرم‌افزار‌های تایپ صوتی" },
    { id: 2, content: "زیرنویس فیلم‌های صوتی" },
    { id: 3, content: "اپلیکیشن‌های مخصوص نابینایان و توان‌یابان" },
    { id: 4, content: "ثبت دقیق صورت جلسات" },
    { id: 5, content: "چت‌بات ها و صورت جلسات" },
  ];
  return (
    <UsageContainer>
      <Container>
        <UsagesWrapper className="container" id="usages">
          <TitleContainer color="#FFFFFF" titleColor="#FFFFFF" opacity="80%">
            <h5>کاربردها</h5>
            <TextContainer>
              <span></span>
              <p>فرایندهایی که سرویس آوانگار در هوشمند شدن آنها کاربرد دارد</p>
            </TextContainer>
          </TitleContainer>

          <UsageListContainer>
            {usagesList.map((item) => (
              <li key={item.id}>{item.content}</li>
            ))}
          </UsageListContainer>
          <UsagesImgContainer>
            <img src={avaImg} alt="ava" />
          </UsagesImgContainer>
        </UsagesWrapper>
      </Container>
    </UsageContainer>
  );
};

export default Usages;
